import { ScrollArea } from "@Rolec-Services/rolec-ui";
import { useState } from "react";
import { StepProps } from "~/components/organisms/step";
import { Details } from "./details";

type SelectedProps = {
  setValue: StepProps["setValue"];
  getValues: StepProps["getValues"];
  removeChargepoint: (serialNumber: string) => void;
};

export function Selected({
  setValue,
  getValues,
  removeChargepoint,
}: SelectedProps) {
  const [chargepoints, setChargepoints] = useState(() =>
    getValues("chargepoint")
  );

  function setSim(index: number, value: boolean) {
    setValue(`chargepoint.${index}.addSim`, value);
    setChargepoints((prev) => {
      const updatedChargepoints = [...prev];
      updatedChargepoints[index].addSim = value;
      return updatedChargepoints;
    });
  }

  return (
    <>
      {!!chargepoints[0].serialNumber && (
        <ScrollArea>
          <div className="flex flex-col gap-4">
            {chargepoints.reverse().map((chargepoint, index) => (
              <Details
                key={`chargepoint-${index}`}
                {...chargepoint}
                removeChargepoint={() =>
                  removeChargepoint(chargepoint.serialNumber)
                }
                setSim={(value) => setSim(index, value)}
              />
            ))}
          </div>
        </ScrollArea>
      )}
    </>
  );
}
